<template>
  <div class="feed-item-display col-12">
    <div class="card card-default mb-4">
      <div class="card-body">
        <img :src="icon" :alt="feedItem.reportType" class="img-thumbnail float-left">
        <p>
          <span class="text-muted small"><i class="far fa-clock fa-fw"></i> {{ feedItem.createdAt | date_time_format }}</span><br/>
          <strong>{{ feedItem.StaffMember.fullName }}</strong> {{ feedItem.verb }} {{ article }} {{ feedItem.reportType }}
          <template v-if="feedItem.address">
            <br/> for <strong>{{ feedItem.address }}</strong>
          </template>
        </p>
      </div>
      <!-- <div class="card-footer text-right">
        <button class="btn btn-primary">
          <i class="fa fa-search fa-fw"></i> View
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FeedItemDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      article () {
        if (['a', 'e', 'i', 'o', 'u'].includes(this.feedItem.reportType.toLowerCase().charAt(0))) {
          return 'an'
        }
        return 'a'
      },
      icon () {
        return 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + this.feedItem.Application.AppIcon.objectKey
      },
      feedItem () {
        return {
          Application: {
            AppIcon: {}
          },
          ...this.object
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/FeedItem.vue